
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalCube as ObiBuoySphericalCubeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-cube.js';
 
 
 

 
 export const ObiBuoySphericalCube = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-cube',
   elementClass: ObiBuoySphericalCubeElement,
   events: {
     
   }
  });
 
 